<nav class="nav flex column">
  @for (item of navItems(); track item) {
    <ol class="nav__item">
      <tnq-nav-item
        [item]="item"
        [isNarrowDisplay]="isNarrowDisplay()"
      ></tnq-nav-item>
    </ol>
  }
</nav>
